import { render, staticRenderFns } from "./EventTag.vue?vue&type=template&id=0d2f90f8&scoped=true"
import script from "./EventTag.vue?vue&type=script&lang=js"
export * from "./EventTag.vue?vue&type=script&lang=js"
import style0 from "./EventTag.vue?vue&type=style&index=0&id=0d2f90f8&prod&lang=scss"
import style1 from "./EventTag.vue?vue&type=style&index=1&id=0d2f90f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2f90f8",
  null
  
)

export default component.exports